<template>
  <div class="page" id="create-project">
    <!--  <div class="decorative-texture top top-fade">
      <img src="../../assets/img/texture.png" />
    </div>-->
    <vue-snotify></vue-snotify>
    <div class="container">
      <div class="page-navigation">
        <div class="row align-items-center">
          <div class="col-auto">
            <button
              class="button back-button tooltip tooltip-bottom" data-tooltip="Regresar"
              @click="
                () => {
                  back();
                }
              "
            >
              <svg width="10.975" height="9.998" viewBox="0 0 10.975 9.998">
                <path
                  id="Color_Overlay"
                  data-name="Color Overlay"
                  d="M26.825,57.835l-3.549-4.046A.634.634,0,0,1,23,53.244v-.366a.7.7,0,0,1,.068-.308.641.641,0,0,1,.14-.282l3.615-4.122a.439.439,0,0,1,.706.028l.205.267a.706.706,0,0,1-.023.861L25.13,52.268h8.343a.564.564,0,0,1,.5.609v.366a.564.564,0,0,1-.5.609H25.236l2.478,2.825a.708.708,0,0,1,.023.861l-.205.266a.462.462,0,0,1-.365.194A.455.455,0,0,1,26.825,57.835Z"
                  transform="translate(-23 -48.001)"
                />
              </svg>
            </button>
          </div>
          <div class="col">
            <div>
              <h1 class="page-title">CRITERIOS DE FILTRADO</h1>
            </div>
          </div>
          <div class="col-1"></div>
        </div>
      </div>
    </div>

    <section>
      <div class="step3">
        <div class="container">
          <!-- <h1 class="section-title">Pasos</h1> -->
          <div class="steps">
            <div class="step">
              <span>01</span>
            </div>
            <div class="step active">
              <span>02</span>
            </div>
            <div class="step">
              <span>03</span>
            </div>
          </div>
          <button class="button fluid next-button width-60" @click="() => {next();}"
          >Siguiente</button>
          <div class="row">
           
            <div class="col-12">
                <h4 class="title-card" style="color: white;">*Separa con comas las palabras a buscar</h4>
            </div>
            <div class="col-12">
              <div class="card head-card keywords-section">
                <div class="title-card">
                  <h4>Keywords</h4>
                </div>
                <div class="card-content">
                  <div class="row">
                    <div class="col-sm-12 col-md-7">
                      <div class="inputype Keywords-input">
                        <form action>
                          <input
                            type="text "
                            v-model="keyword"
                            placeholder="ej. Mi Keyword"
                            @change="
                              val => {
                               
                              }
                            "
                            v-on:keydown.enter.prevent="next"
                          />
                        </form>
                      </div>
                    </div>
                    <div class="col-sm-12 col-md-2">
                      <div class="Keywords-button-container">
                      
                            <button
                              :class="[
                                'button',
                                'fluid',
                                'alternative',
                                'noMargin',
                                keyword ? '' : 'disabled'
                            ]"
                              @click="() => next()"
                              :disabled="keyword == ''"
                            >Buscar
                            </button>
                      </div>
                    </div>
                    <!-- <div class="col-sm-12 col-md-3">
                      <div class="checkbox checkAND">
                        <label class="active">
                          <div class="user-avatar">
                            <div class="data-avatar">Contiene todas las etiquetas</div>
                          </div>
                          <input class="box" type="checkbox" :checked="andQuery" @click="selectAND()" />

                          <span class="nbox checkElement">
                            <svg viewBox="0 0 14.018 13.003">
                              <path
                                id="Rectángulo_9"
                                data-name="Rectángulo 9"
                                d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                transform="translate(-304.98 -380.994)"
                                fill="#fff"
                              />
                            </svg>
                          </span>
                        </label>
                      </div>
                    </div> -->
                  </div>
                  
                  <!-- <div class="chip-button">
                    <div
                      class="chip primary iconed"
                      v-for="(item, index) in keywords"
                      v-bind:key="index"
                    >
                      {{ item }}
                      <button class="icon" @click="() => removeKeyword(index)">
                        <svg
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="feather feather-x"
                        >
                          <line x1="16" y1="8" x2="8" y2="16" />
                          <line x1="8" y1="8" x2="16" y2="16" />
                        </svg>
                      </button>
                    </div>
                  </div> -->
                  
                </div>
              </div>
            </div>
            <div class="col-12">
              <div class="card head-card time-section">
                <div class="title-card">
                  <h4>Tiempo</h4>
                </div>
                <div class="card-content">
                  <div class="row">
                    <div class="col-12 col-md-8 col-lg-8">
                      <div class="calendar-container">
                        <h4 class="interiorTitle">Selecciona el rango de fecha para la búsqueda</h4>
                        <select v-model="dselected" class="dselected" @change="selectRange()">
                          <option value="7">Ultimos 7 días</option>
                          <option value="15">Ultimos 15 días</option>
                          <option value="30">Ultimos 30 días</option>
                          <option value="60">Ultimos 60 días</option>
                          <option value="rango">Rango personalizado</option>
                        </select>
                        <br />

                        <v-date-picker
                          :columns="$screens({ default: 1, lg: 2 })"
                          color="gray"
                          is-inline
                          v-model="range"
                          mode="range"
                          :min-date='getMinDate'
                          v-if="dselected == 'rango'"
                        />
                        <div class="range" v-show="start">Del {{ start }} a {{ end }}</div>
                      </div>
                    </div>
                    <div class="col-12 col-md-4 col-lg-4">
                      <div class="text-center">
                        <h4 class="interiorTitle">Horario</h4>
                        <div class="row no-glutters">
                          <div class="col-6">
                            <input
                              class="radioB"
                              type="radio"
                              id="uno"
                              value="todo"
                              v-model="hpicked"
                              @change="hchange"
                            />
                            <label for="checkbox">Todo el día</label>
                          </div>
                          <div class="col-6">
                            <input
                              class="radioB"
                              type="radio"
                              id="uno"
                              value="rango"
                              v-model="hpicked"
                            />
                            <label for="checkbox">Rango</label>
                          </div>
                        </div>
                      </div>

                      <div class="row justify-content-center" v-if="hpicked == 'rango'">
                        <div class="col-auto">
                          <div class="select-container">
                            <h4 class="labelTitle">Hora inicio</h4>
                            <vue-timepicker v-model="hini" format="HH:mm" @input="changeHour"></vue-timepicker>
                          </div>
                        </div>
                        <div class="col-auto">
                          <div class="select-container">
                            <h4 class="labelTitle">Hora final</h4>
                            <vue-timepicker v-model="hfin" format="HH:mm" @input="changeHour"></vue-timepicker>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!---ROW-->
          <div class="card head-card alerts-section">
            <div class="title-card">
                <h4>Alertas</h4>
            </div>
            <div class="card-content">
              <div class="collapsible " >
                <div class="trigger bOscuro alerta">
                    <div class="row align-items-center">
                        <div class="col-auto">
                            <div class="trigger-icon">
                                <font-awesome-icon icon="envelope" />
                            </div>
                        </div>
                        <div class="col"> <div class="trigger-content">Enviar por correo</div></div>
                        <div class="col-auto touchpad" >
                           <div class="checkbox ">
                                <label class="active noPadding">

                                <input class="box" type="checkbox"  @click="selectAlert(0)" />

                                <span class="nbox checkElement">
                                    <svg viewBox="0 0 14.018 13.003">
                                    <path
                                        id="Rectángulo_9"
                                        data-name="Rectángulo 9"
                                        d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                        transform="translate(-304.98 -380.994)"
                                        fill="#fff"
                                    />
                                    </svg>
                                </span>
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div :class="['body',{'hide':!checkEmail}]">
                    <div class="row">
                       <div class="col-12">
                            <div class="text-center">
                                <!--<h4 class="interiorTitle">Horario</h4>-->
                                <div class="row no-glutters">
                                    <div class="col-6">
                                        <input
                                        class="radioB"
                                        type="radio"
                                        id="typeEmail"
                                        value="correos"
                                        v-model="pickedTypeEmails"
                                        />
                                        <label for="checkbox">Correos</label>
                                    </div>
                                    <div class="col-6">
                                        <input
                                        class="radioB"
                                        type="radio"
                                        id="typeEmail"
                                        value="grupos"
                                        v-model="pickedTypeEmails"
                                        />
                                        <label for="checkbox">Grupos</label>
                                    </div>
                                </div>
                            </div><br>
                            <div class="row justify-content-center">
                              <div class="col-sm-12 col-md-6">
                                <div class="inputype Keywords-input">
                                  <form action>
                                    <input
                                      type="text "
                                      v-model="input"
                                      :placeholder="pickedTypeEmails=='correos'? 'nombre@email.com': 'nombre grupo'"
                                    />
                                  </form>
                                </div>
                              </div>
                              <!--<div class="col-sm-6 col-md-2">
                                <button
                                  :class="[
                                    'tooltip',
                                    'button',
                                    'fluid',
                                    'alternative',
                                    'noMargin',
                                    email ? '' : 'disabled'
                                  ]"
                                  data-tooltip="buscar"
                                  :disabled="email == ''"
                                > Buscar</button> 
                              </div>-->
                              <div class="col-sm-6 col-md-2">
                                <button :class="[
                                  'button',
                                  {'alternative':items.length==0},
                                  'noMargin',
                                  'tooltip'
                                  ]" 
                                  data-tooltip="Todos"
                                  @click="setAll"
                                >
                                  <font-awesome-icon icon="globe-americas" />
                                </button>
                              </div>


                            </div>
                            <div class="row">
                              <div class="chip-button">
                                    <div
                                        class="chip iconed touchpad"
                                        @click="addItem(item)"
                                        v-for="(item, index) in results"
                                        v-bind:key="'result'+index"
                                    >
                                        {{ item.nombre }}
                                        <br>
                                        {{ pickedTypeEmails=='correos'? item.key:''}}
                                    </div>
                                </div>
                            </div>
                            <br>
                            <div class="row" style="border-top:1px solid #00B99E" v-if="items.length>0">
                              <div class="col-12">
                              <h4>Correos a enviar:</h4>
                              <div class="chip-button" >
                                    <div
                                        class="chip iconed touchpad"
                                        v-for="(item, index) in items"
                                        v-bind:key="'items'+index"
                                    >
                                        {{ item.nombre }}
                                        <br>
                                        {{ pickedTypeEmails=='correos'? item.key:''}}
                                        <button class="icon" @click="() => removeItem(index)">
                                            <svg
                                                viewBox="0 0 24 24"
                                                stroke="currentColor"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                                class="feather feather-x"
                                            >
                                                <line x1="16" y1="8" x2="8" y2="16" />
                                                <line x1="8" y1="8" x2="16" y2="16" />
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                              </div>
                            </div>
                        </div>
                    </div>
                </div>
              </div>
              <div class="collapsible"> <!-- Se mantiene siempre visible EGM 230126-->
                            <div class="trigger bOscuro alerta">
                                <div class="row align-items-center">
                                    <div class="col-auto">
                                        <div class="trigger-icon">
                                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="22" height="22" class="main-grid-item-icon" fill="none">
                                <path d="M6.579 8.121c.209-.663.778-1.457 1.19-1.66.183-.09.319-.11.763-.11.522 0 .548.005.684.14.088.095.328.606.673 1.432.292.71.533 1.315.533 1.347 0 .146-.293.61-.627 1.002-.23.267-.365.47-.365.543 0 .068.167.381.376.69.506.757 1.44 1.696 2.167 2.177.568.376 1.582.867 1.785.867.152 0 .429-.272.992-.982.23-.287.434-.495.512-.511.068-.021.235.005.37.057.392.152 2.371 1.117 2.476 1.211.203.188.037 1.264-.267 1.702-.464.68-1.79 1.259-2.663 1.17-.636-.068-2.14-.564-3.117-1.029-1.253-.6-2.574-1.697-3.644-3.038-.611-.763-1.227-1.692-1.493-2.246-.36-.751-.491-1.331-.455-2 .016-.287.068-.631.11-.762Z" fill="#ffffff" />
                                <path clip-rule="evenodd" d="M.606 9.5C1.582 4.491 5.576.76 10.709.06c.705-.1 2.684-.068 3.368.046.715.126 1.66.371 2.24.59 3.832 1.426 6.663 4.72 7.466 8.683.35 1.729.272 3.755-.203 5.457-1.133 4.03-4.423 7.205-8.511 8.218-2.663.658-5.462.37-7.983-.81l-.617-.292-3.226 1.029C1.473 23.545.01 23.994 0 23.983c-.01-.01.45-1.415 1.029-3.112l1.05-3.096-.424-.84C.48 14.569.12 12.01.605 9.498Zm21.172-.408c-1.028-3.76-4.297-6.626-8.145-7.148-2.099-.282-4.078.037-5.9.956-4.417 2.234-6.522 7.341-4.93 11.957.204.59.752 1.702 1.092 2.213l.271.408-.605 1.775a69.688 69.688 0 0 0-.606 1.817c0 .026.84-.224 1.864-.548a99.767 99.767 0 0 1 1.9-.596c.022 0 .225.11.45.24 2.428 1.447 5.456 1.76 8.187.852a9.927 9.927 0 0 0 6.48-6.945 9.998 9.998 0 0 0-.058-4.98Z" fill="#ffffff" fill-rule="evenodd" />
                                </svg>
                                        </div>
                                    </div>
                                    <div class="col">
                                        <div class="trigger-content">Enviar notificacion por WhatsApp</div>
                                    </div>
                                    <div class="col-auto touchpad">
                                        <div class="checkbox ">
                                            <label class="active noPadding">

                                                <input class="box" type="checkbox" v-model="checkwhatsapp"
                                                    @click="selectAlert(1)" />

                                                <span class="nbox checkElement">
                                                    <svg viewBox="0 0 14.018 13.003">
                                                        <path id="Rectángulo_9" data-name="Rectángulo 9"
                                                            d="M304.98,386.9s1.489,1.413,3.5,3.546c4.553-2.794,10.514-9.457,10.514-9.457l-10.514,13Z"
                                                            transform="translate(-304.98 -380.994)" fill="#fff" />
                                                    </svg>
                                                </span>
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>   
            </div>
            <!--<div class="alerts-button-container">
              <div class="row justify-content-center">
                <div class="col-auto">
                  <button class="button fluid alternative">GUARDAR</button>
                </div>
                <div class="col-auto">
                  <button class="button fluid large dark">CANCELAR</button>
                </div>
              </div>
            </div>-->
        </div><!-- card alertas -->
        </div>
        <confirm :show="show" :smsModal="smsModal" @aceptar="deleteSearch" @cancelar="cancelDelete"></confirm>
      </div>
    </section>
  </div>
</template>
<script>
// @ is an alias to /src
import axios from "axios";
import VueTimepicker from "vue2-timepicker";
import confirm from "@/components/confirm";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faEnvelope, faGlobeAmericas } from "@fortawesome/free-solid-svg-icons";
library.add(faEnvelope)
library.add(faGlobeAmericas)
// CSS
import "vue2-timepicker/dist/VueTimepicker.css";
import moment from "moment";
export default {
  name: "step3",
  components: {
    VueTimepicker,
    confirm
  },
  data: () => ({
    nProyecto: "",
    rSelected: true,
    range: {
      start: null, // Jan 16th, 2018
      end: null // Jan 19th, 2018
    },
    start: null,
    end: null,
    keywords: [],
    keyword: "",
    galertas: false,
    hini: "00:00",
    hfin: "23:59",
    dselected: 60,
    hpicked: "todo",
    andQuery: true,
    // alertas
    checkEmail:false,
    pickedTypeEmails:"",
    cmd:"",
    items:[],
    itemsKey:[],
    LastEvaluatedKey:null,
    selectedIndex:-1,
    url:'',
    input:"",
    all:true,
    results:[],
    checkwhatsapp : false,
    show: false,
    smsModal: "¿Desea eliminar todas la notificacion de whatsapp que este relacionada a la búsqueda?",
  }),

  methods: {
    cancelDelete() {
            this.checkwhatsapp = true;
            this.show = false;
        },
    deleteSearch() {
      
      let key_notifica = this.$store.state.search.table+"_"+this.$store.state.search.key;
      console.log(key_notifica, "=====>>>>>aquiq")
      var post_data = {
          key: key_notifica,
          token: this.token,
          };
      var self = this;
      axios.post(this.url + "deleteConfigWa", JSON.stringify(post_data))
          .then(response => {
          self.show = false;
                    if (response.data.success) {
                        self.success('Notificacion eliminada');
                    }
                })
                .catch(function (error) {
                    self.show = false;
                    self.error(error);
                });
        
        },
    selectAND() {
      this.andQuery = !this.andQuery;
      this.$store.commit("saveAND",this.andQuery);
    },
    changeHour(data){
      var time = {
        ini : this.hini,
        fin : this.hfin
      }
      this.$store.commit("addTime", time);
    },
    hchange() {
      this.hini = "00:00";
      this.hfin = "23:59";
      var time = {
        ini : this.hini,
        fin : this.hfin
      }
      this.$store.commit("addTime", time);
    },
    selectRange() {
      this.rSelected = true;
      console.log("Range");
      console.log(this.dselected);
      var d = new Date();
      console.log("Today is: " + d);

      if (this.dselected != "range") {
        this.$store.commit("addrDias", this.dselected);
      } else {
        this.$store.commit("addrDias", "range");
      }
    },
    /*cleanFiList(fi) {
      console.log(fi);

      var list = {};
      Object.keys(fi).forEach(function(item) {
        console.log(item);
        if (fi[item].length > 0) {
          if (fi[item][0] == "all") {
            list[item] = [];
          } else {
            list[item] = fi[item];
          }
        }
      });

      return list;
    },*/
    cleanFiList(fi, fiParams) {
      //naye
      var list = {};
      Object.keys(fiParams).forEach(function(item) {
        if (fiParams[item].length > 0) {
          list[item] = fi[item];
        }
      });
      return list;
    }, //naye
    async next() {
      console.log('next');
      let d = new Date(this.range.start);
      let de = new Date(this.range.end);
      let ms = d.getMonth() + 1;
      let me = de.getMonth() + 1;
      let start = d.getFullYear() + "-" + ms + "-" + d.getDate();
      let end = de.getFullYear() + "-" + me + "-" + de.getDate();

      this.$store.commit("addKeywords", this.keywor);
      let dates = {
        ini: start,
        fin: end
      };

      console.log("dates");
      console.log(dates);

      let time = {
        ini: this.hini,
        fin: this.hfin
      };
      this.$store.commit("addRange", dates);
      this.$store.commit("addTime", time);
      console.log("fiParams");
      var fiParams = this.$store.state.projectConfig.fiParams;

      //var cleanList = this.cleanFiList(this.$store.state.projectConfig.fiList);
      var fi = this.$store.state.projectConfig.fiList;
      
      var cleanList = this.cleanFiList(fi, fiParams);
      console.log("cleanList");
      console.log(cleanList);
      var cleanParam = this.cleanParams(fiParams);
      console.log("#######>>>>>>>>>>>> parametros",cleanParam )
      console.log("#######>>>>>>>>>>>> fis",fi )
      var gaugeQuery = {
        fi: cleanList,
        ubicacion: "global",
        fiParams: cleanParam, //naye
        fecha: this.$store.state.projectConfig.fecha,
        hora: this.$store.state.projectConfig.hora,
        keywords: this.keyword,
        dias: this.$store.state.projectConfig.nDias,
        andQuery: this.$store.state.projectConfig.andQuery,
        alertWP :  this.checkwhatsapp
      };

    
      if (this.rSelected == false) {
        this.error("Selecciona un rango de fecha");
      } else {
        if (this.hpicked == "") {
          this.error("Selecciona un rango de hora");
        } else {
          if (this.keyword == "") {
            this.error("Ingresa por lo menos un keyword de búsqueda");
          } else {
            if (this.$store.state.projectConfig.dashKey != "") {
              this.$router.push({ path: "/busqueda/nueva/step3" });
            } else {
              //naye
              var p = { from: "busqueda", fromParams: { step: "step2" } };
              this.$store.commit("saveBack2", p);

              //seleccionó alerta?
              console.log('alerta?')
              console.log(this.checkEmail);
              if(this.checkEmail){
                var r = await  this.sendEmails(gaugeQuery);
                if(r.success==false){ this.error('Error al enviar emails'); return 0;}
                else{
                  gaugeQuery.alerta = true;
                  gaugeQuery.alertType = this.pickedTypeEmails;
                  gaugeQuery.alertKeys = this.itemsKey;
                  this.success('Email Enviado');
                }
              }
            var params ={
              mode : this.$store.state.projectConfig.mode,
              key : this.$store.state.projectConfig.queryKey,
              query:gaugeQuery
            }

            var r = await this.saveSearch(params);
           
            console.log(r,"auiiiiiii3##");
            this.$store.commit("saveSearch", r.data);
            
            this.$store.dispatch('setSelectedSearch',r.data.key);

            if(this.checkwhatsapp){
              var setNotific ={
              key_busqueda : r.data.key,
              table_busqueda :  r.data.table,
              action : this.$store.state.projectConfig.mode,
              keywords : r.data.query.keywords,
              fuentes : r.data.query.fi,
              active:true,
              frecuencia : 1
            }
          
              this.$store.commit('setNotificacionWp', setNotific);
              this.$router.push("/config-wa");
            }else{
              
                this.deleteSearch()
              
              this.$router.push({
                name: "busquedas"
             });
            }
            

            
            }
          }
        } //naye
      }
    },
    getItems(){
            var self = this;
            var post_data = {
                token: this.token,
                limit:10
            };
            if(this.LastEvaluatedKey!=null) post_data['LastEvaluatedKey'] = this.LastEvaluatedKey;

            axios.post(self.url+self.cmd,JSON.stringify(post_data))
            .then(function(response) {
                self.isLoading = false;
                console.log(response)
                if(self.items.length==0){
                    self.items = response.data.data.result;
                }else{
                    self.items = [].concat(self.items,response.data.data.result);
                }
                self.LastEvaluatedKey = (response.data.data.LastEvaluatedKey)?  response.data.data.LastEvaluatedKey:null;
            })
            .catch(function(error) {
                self.isLoading = false;
                self.error(error);
            });
    },
    removeKeyword(index) {
      this.keywords.splice(index, 1);
      this.$store.commit("addKeywords", this.keywords);
    },
    addKeyword() {
      if (this.keyword != "") {
        this.keywords.push(this.keyword);
        this.$store.commit("addKeywords", this.keywords);
        this.keyword = "";
      }
    },
    setAll(){
      if(this.items.length>0){
        this.itemsKey = [];
        this.items = [];
        this.results = [];
      }
    },
    removeItem(index){ //from alerts
      var i = this.itemsKey.indexOf(this.items[index].key);
      this.itemsKey.splice(i,1);
      this.items.splice(this.items[index],1);
    },
    addItem(item){
      console.log('addItem');
      if(this.itemsKey.indexOf(item.key)==-1) { //no lo ha agregado antes?
        this.itemsKey.push(item.key);
        this.items.push(item);
        this.input = "";
        this.results = [];
      }else{
        this.error('ya está agregado')
      }
  
      
    },
    selectAlert(index){
      this.selectedIndex = index;
      switch(index){
        case 0: 
          this.checkEmail = !this.checkEmail; 
          if(this.checkEmail){
            this.pickedTypeEmails = "correos";
          }
          else{
            this.pickedTypeEmails = "";
            this.clear();
          }
        break;
        case 1:
        //  if(this.checkwhatsapp){
         //   this.show = true;
        //  }
        break;
      }
    },
    async sendEmails(query){
      console.log(this.pickedTypeEmails);
      console.log(this.items);
      var post_data = {
        query:query,
        token:this.token,
        type:this.pickedTypeEmails,  //correo o grupos?
        items:this.itemsKey, //array de correos o grupos
      }
      var self = this;
      return new Promise((resolve)=>{
        axios.post(self.url+"sendEmails",JSON.stringify(post_data))
            .then(function(response) {
                self.isLoading = false;
                console.log(response)
                if(response.data.success)
                  resolve({success:true})
                else
                  resolve({success:false,error:response.data.error})
            })
            .catch(function(error) {
                self.isLoading = false;
                 resolve({success:false,error:error})
        });
      })
      


    },
    clear(){
      this.itemsKey = [];
      this.items= [];
      this.cmd = "";
      this.results = [];
    },
    cleanParams(param) {
      var list = {};
      Object.keys(param).forEach(function(item) {
        if (param[item].length > 0) {
          list[item] = param[item];
        }
      });

      return list;
    },
    async saveSearch(params){

      var post_data = {
        token:this.token,
        query:params.query
      };
      var cmd = "saveSearch";
      if(params.mode == 'edit'){ 
        post_data.key = params.key,
        cmd = "editSearch";
      }
      return new Promise((resolve,reject)=>{
         var self = this;
            axios.post(self.url + cmd , JSON.stringify(post_data))
            .then(response => {
                if (response.data.success) {
                    resolve({success:true,data:response.data.data})
                }
                else{
                  resolve({success:false,error:response.data.error})
                }
            })
            .catch(function(error) {
               resolve({success:false,error:error})
            });

      })
           
    },
    setConfig(){
      this.checkwhatsapp = this.$store.state.projectConfig.noWP;
      this.keywords = this.$store.state.projectConfig.keywords;
      this.keyword = this.$store.state.projectConfig.keywords;
      this.dselected = this.$store.state.projectConfig.nDias;
      this.andQuery = this.$store.state.projectConfig.andQuery;
      if(this.dselected == "rango"){
        var fecha = this.$store.state.projectConfig.fecha;
        var fecha_arr = fecha.ini.split('-');
        var anio = fecha_arr[0];
        var mes = parseInt(fecha_arr[1]);
        var dia = parseInt(fecha_arr[2]);
        if(mes<=9) mes = '0' + mes;
        if(dia<=9) dia = '0' + dia;        
        this.start = dia + '/' + mes + '/' + anio;
        this.range.start = new Date(anio,parseInt(mes)-1,dia);

        var fecha_arr = fecha.fin.split('-');
        var anio = fecha_arr[0];
        var mes = parseInt(fecha_arr[1]);
        var dia = parseInt(fecha_arr[2]);
        if(mes<=9) mes = '0' + mes;
        if(dia<=9) dia = '0' + dia;
        this.end = dia + '/' + mes + '/' + anio;
        this.range.end = new Date(anio,parseInt(mes)-1,dia);
      }

      this.hini = this.$store.state.projectConfig.hora.ini;
      this.hfin = this.$store.state.projectConfig.hora.fin;
      if(this.hini == "00:00" && this.hfin == "23:59")
        this.hpicked = "todo";
      else
        this.hpicked = "rango"
    },
    error(msg){
      this.$snotify.error(msg, this.$store.state.error);
    },
    success(msg){
      this.$snotify.success(msg, this.$store.state.success);
    },
    back() {
      this.$router.push({ path: "/busqueda/nueva/step1" });
    },

  },
  watch: {
    input(){
       console.log(this.input);
      if(this.input.trim() == '') { this.results = [];return 0; }
     
      var self = this;
      var post_data = {
        token:this.token,
        nombre:this.input
      }
      var cmd = "searchEmail";
      if(this.pickedTypeEmails=="grupos") cmd = "searchGroup"; 
      axios.post(self.url+cmd,JSON.stringify(post_data))
            .then(function(response) {
                self.isLoading = false;
                console.log(response)
                if(response.data.success)
                  self.results = response.data.data.result;
                else
                  self.error(response.data.error);
                //self.LastEvaluatedKey = (response.data.data.LastEvaluatedKey)?  response.data.data.LastEvaluatedKey:null;
            })
            .catch(function(error) {
                self.isLoading = false;
                self.error(error);
      });
    },
    range(val) {
      console.log("Change");
      let d = new Date(val.start);
      let de = new Date(val.end);
      let ms = d.getMonth() + 1;
      let me = de.getMonth() + 1;
      this.start = d.getDate() + "/" + ms + "/" + d.getFullYear();
      this.end = de.getDate() + "/" + me + "/" + de.getFullYear();
    },
    pickedTypeEmails(){
      this.clear();
      if(this.pickedTypeEmails=="correos") {  this.cmd = "getEmails"; }//this.getItems();}
      if(this.pickedTypeEmails=="grupos"){ this.cmd = "getGroups"; }//this.getItems();}
    }
  },
  beforeMount() {
    this.url = this.$store.getters.getMainUrl;
    this.setConfig();
    console.log("BeforeStep3");
    this.selectRange();
  },
  computed:{
    token(){
      return this.$store.getters.getToken;
    },
    getMinDate(){
            var today = moment();
            var minF = today.subtract(60, 'days'); 
            var minDate = new Date(minF);
            return minDate;
    },
  },
  mounted() {
    window.scrollTo(0, 0);
  }
};
</script>

<style  lang="scss">


button[disabled], html input[disabled] {
  cursor: default;
  background-color:#fff!important ;
  border:1px solid #00B99E;
  color:#062633!important
}

#create-project .radio-button-container .radio-button label{
  padding:10px;
}

.keywords-section .Keywords-input input {
border: 1px solid #00B99E;
}

.keywords-section .Keywords-input input::placeholder {
  color: #062633;
}

.range {
  margin-top: 10px;
}

.text-left {
  text-align: left;
  max-width: 300px;
  width: 100%;
  margin: 0 auto;
}

.checkElement {
  background-color: #ffffff;
  position: absolute;
  right: 15px;
  border: solid 1px #00b99e;

  top: 50%;
  transform: translateY(-50%);
  -webkit-transform: translateY(-50%);
  -moz-transform: translateY(-50%);
  width: 20px;
  height: 20px;
}

.checkAND label input:checked + .checkElement {
  background-color: #00b99e;
}

#create-project .next-button{
  padding: 10px 20px;
}

</style>
